import styled from 'styled-components';
import { Typography } from 'antd';
import { ReactNode } from 'react';
import {COLORS, TYPOGRAPHY_SIZES} from "./constants";

const { Text: AText } = Typography;

export const Text = styled(AText)<{
  color?: string;
  weight?: number;
  size?: string;
  width?: number;
  children: string | ReactNode;
}>`
  font-size: ${props => props.size || TYPOGRAPHY_SIZES.NORMAL};
  font-weight: ${props => props.weight || 400};
  color: ${props => props.color || COLORS.colorText};
  width: ${props => `${props.width}px` || 'auto'};
`;
